import { classNames } from '@dimjs/utils';
import { flatbizDate } from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { useRef } from 'react';
import { IphoneBottomAdaptive } from '../iphone-bottom-adaptive';
import { ListItem } from '../list/list-item';
import { ModalDrawer, ModalDrawerProps } from '../modal-drawer';
import { PickerColumnItem } from '../picker/types';
import { DateView, DateViewProps } from './date-view';
import './styles/date-pick.less';

export interface DatePickerProps {
  className?: string;
  visible?: boolean;
  title: string | JSX.Element;
  modalProps?: Omit<ModalDrawerProps, 'visible' | 'className' | 'onClose'>;
  onClose?: () => void;
  dateViewProps: Omit<DateViewProps, 'className' | 'defaultDate' | 'onChange' | 'value'>;
  value?: string;
  onChange?: (pickerColumnItem: PickerColumnItem<string>) => void;
  defaultDate?: string;
}

/**
 * 日期选择
 */
export const DatePicker = (props: DatePickerProps) => {
  const selectedDateRef = useRef<PickerColumnItem<string>>();
  const defaultDate = props.defaultDate || flatbizDate.format(new Date(), 'YYYY-MM-DD');

  const onChange = hooks.useCallbackRef((dateItem: PickerColumnItem) => {
    selectedDateRef.current = dateItem as PickerColumnItem<string>;
  });

  const onConfirm = hooks.useCallbackRef(() => {
    if (selectedDateRef.current) {
      props.onChange?.(selectedDateRef.current);
    } else {
      const selectedDate = flatbizDate.format(props.value || defaultDate, 'YYYY-MM-DD');
      props.onChange?.({
        label: selectedDate,
        value: selectedDate,
      });
    }
  });

  return (
    <ModalDrawer
      className={classNames('v-date-picker', props.className)}
      position="bottom"
      visible={props.visible || false}
      {...props.modalProps}
      onClose={props.onClose}
    >
      <ListItem
        prefix={<span onClick={props.onClose}>取消</span>}
        extra={<span onClick={onConfirm}>确定</span>}
      >
        {props.title}
      </ListItem>
      <DateView {...props.dateViewProps} value={props.value} onChange={onChange} defaultDate={defaultDate} />
      <IphoneBottomAdaptive />
    </ModalDrawer>
  );
};

DatePicker.domTypeName = 'DatePicker';
